import { Dictionary, DictionaryResponse } from '../types/dictionary'

function mapDictionary(response: Partial<DictionaryResponse>): Dictionary {
  return {
    id: Number(response?.id || 0) || 0,
    name: String(response?.name || ''),
    code: String(response?.code || ''),
    image: String(response?.image || ''),
    position: Number(response?.position || 0) || 0,
    description: String(response?.description || ''),
    active: response?.active || false,
  }
}

function mapDictionaries(response: Partial<DictionaryResponse>[]): Dictionary[] {
  return response.map((dto) => {
    return mapDictionary(dto)
  })
}

const mappers = {
  mapDictionary,
  mapDictionaries,
}

export default mappers
